export const SPEED_TEST_OPTIONS = [
  { value: 'inspectsurvival', label: '存活检测（App同款）' },
  { value: 'spot_kline', label: '现货 K 线' },
  { value: 'spot_depth', label: '现货盘口' },
  { value: 'futures_kline', label: '合约 K 线' },
  { value: 'futures_depth', label: '合约盘口' },
];

const BUILDERS = {
  inspectsurvival: (base) => `${base}/attr/a/inspectsurvival?productName=lvbit`,
  spot_kline: (base) =>
    `${base}/attr/a/marketcondition/getKline?symbol=BTC_USDT&interval=15m&limit=1`,
  spot_depth: (base) =>
    `${base}/attr/a/marketcondition/getDepth?symbol=BTC_USDT&level=5`,
  futures_kline: (base) =>
    `${base}/next/f/market/config/mc/getKline?symbol=btc_usdt&interval=15m&limit=1`,
  futures_depth: (base) =>
    `${base}/next/f/market/config/mc/getDepth?symbol=btc_usdt&level=5`,
};

export function buildSpeedTestUrl(lineUrl, type = 'inspectsurvival') {
  const base = (lineUrl || '').trim().replace(/\/+$/, '');
  const build = BUILDERS[type] || BUILDERS.inspectsurvival;
  return build(base);
}

export function runSpeedTest(url, timeoutMs = 10000) {
  return new Promise((resolve) => {
    const start = Date.now();
    const xhr = new XMLHttpRequest();
    const timer = setTimeout(() => {
      xhr.abort();
      resolve({ ok: false, ms: timeoutMs, error: '超时' });
    }, timeoutMs);

    xhr.open('GET', url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      clearTimeout(timer);
      const ms = Date.now() - start;
      const ok = xhr.status >= 200 && xhr.status < 400;
      resolve({
        ok,
        ms,
        status: xhr.status,
        error: ok ? null : `HTTP ${xhr.status}`,
      });
    };
    xhr.onerror = function () {
      clearTimeout(timer);
      resolve({
        ok: false,
        ms: Date.now() - start,
        error: '网络错误或跨域被拦截',
      });
    };
    xhr.send();
  });
}

export async function runBatchSpeedTest(lineItems, type) {
  const tasks = (lineItems || []).map(async (item) => {
    if (!item.lineUrl) {
      return {
        id: item.id,
        result: { ok: false, ms: 0, error: '无线路地址', loading: false },
      };
    }
    const url = buildSpeedTestUrl(item.lineUrl, type);
    const result = await runSpeedTest(url);
    return { id: item.id, result: { ...result, loading: false } };
  });
  return Promise.all(tasks);
}
